import React from "react";
import { TextWrapperSpan, Wrapper } from "../../constants/common/StyledGlobalConstants";
import CPNotification from "../../pages/Login/CPNotification";
import { connect } from "react-redux";
import { addCurrencySymbol} from "../../util/negativeAmountHandler";
import { InvoiceTextLink, Spacer } from "./QuickBillSummary";
import PropTypes from "prop-types";

const MultiCADueAmountNotification = ({ t, responseData, getOtherContractAccountDetails, ...props }) => {
  return (
    <>
      {responseData &&
        responseData.length !== 0 &&
        responseData.filter((item) => item?.contractAccount !== props.contractAccount && item?.lastDueDate !== "" && item?.outStandingCharges !== "0")
          .length !== 0 && (
          <Spacer bottom="8px">
            <CPNotification isOpen={true} notificationType="cfsterror" height="auto" width="100%" closeButton={false} role={""}>
              {responseData
                .filter((item) => item.contractAccount !== props.contractAccount)
                .map((item, i) => {
                  if (item?.lastDueDate !== "") {
                    return props.userLanguage == "de-DE" ? (
                      <Wrapper fontFamily="neue-haas-grotesk-text" paddingTop={i > 0 ? "1em" : "0em"} fontSize="0.875rem">
                        {`In Ihrem Reveal-Konto `}
                        <TextWrapperSpan fontWeight="bold">
                          {"  " + addCurrencySymbol(item?.outStandingCharges, props.currencySymbol)}
                        </TextWrapperSpan>
                        {` steht ein Betrag von `}
                        <TextWrapperSpan fontWeight="bold">{item?.contractAccount}</TextWrapperSpan>
                        {` aus, der am `}
                        <TextWrapperSpan fontWeight="bold">{item?.lastDueDate.split(",").join(", ")}</TextWrapperSpan>
                        {` fällig war. `}
                        {
                          <InvoiceTextLink
                            style={{ width: "fit-content", cursor: "pointer", borderColor: "#000000", color: "#000000" }}
                            id="other-contract-account"
                            size="small"
                            type="standAlone"
                            aria-labelledby="Other Contract Account"
                            tabIndex="0"
                            onClick={() => getOtherContractAccountDetails(item?.contractAccount)}
                            onKeyDown={(e) => e.key === "Enter" && getOtherContractAccountDetails(item?.contractAccount)}
                          >
                            {`Bitte bezahlen Sie den ausstehenden Betrag`}
                          </InvoiceTextLink>
                        }
                        {", um eine vorübergehende Sperrung Ihres Reveal-Kontos zu verhindern. "}
                      </Wrapper>
                    ) : (
                      <Wrapper fontFamily="neue-haas-grotesk-text" paddingTop={i > 0 ? "1em" : "0em"} fontSize="0.875rem">
                        {t("There is an outstanding balance of")}
                        <TextWrapperSpan fontWeight="bold">
                          {"  " + addCurrencySymbol(item?.outStandingCharges, props.currencySymbol)}
                        </TextWrapperSpan>
                        {t("on your Reveal account")}
                        <TextWrapperSpan fontWeight="bold">{item?.contractAccount}</TextWrapperSpan>
                        {", "}
                        {t("which was due since")}
                        <TextWrapperSpan fontWeight="bold">{item?.lastDueDate.split(",").join(", ")}</TextWrapperSpan>
                        {". "}
                        {t("To avoid suspension of your Reveal account")}
                        {
                          <InvoiceTextLink
                            style={{ width: "fit-content", cursor: "pointer", borderColor: "#000000", color: "#000000" }}
                            id="other-contract-account"
                            size="small"
                            type="standAlone"
                            aria-labelledby="Other Contract Account"
                            tabIndex="0"
                            onClick={() => getOtherContractAccountDetails(item?.contractAccount)}
                            onKeyDown={(e) => e.key === "Enter" && getOtherContractAccountDetails(item?.contractAccount)}
                          >
                            {t("please pay the outstanding balance.")}
                          </InvoiceTextLink>
                        }{" "}
                      </Wrapper>
                    );
                  } else {
                    return <></>;
                  }
                })}
            </CPNotification>
          </Spacer>
        )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    contractAccount: state.BILLING.contractAccount,
    currencySymbol: state.BILLING.currencySymbol,
    userLanguage: state.ACCOUNT.userLanguage,
  };
};

MultiCADueAmountNotification.propTypes = {
  t: PropTypes.func.isRequired,
  responseData: PropTypes.array,
  getOtherContractAccountDetails: PropTypes.func,
  contractAccount: PropTypes.string,
  currencySymbol: PropTypes.string,
  userLanguage: PropTypes.string,
};

export default connect(mapStateToProps, null)(MultiCADueAmountNotification);
